import axios from "axios";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import {
  FIT_BIT_LINKED_ENDPOINT,
  GET_GENERAL_PAGES,
  GET_MOOD_NOTIFICATION,
  GOOGLE_FIT_LINKED_ENDPOINT,
  GOOGLE_FIT_UNLINKED_ENDPOINT,
} from "../config/ApisCollection";

// USE Less
export const storeLocalStorage = (itemLabel, itemName) => {
  secureLocalStorage.setItem(itemLabel, itemName);
};

export const getPathPrefix = () => {
  const pathParts = window.location.pathname.split("/");
  const category = pathParts[1];

  if (category === "men") {
    return "/men/";
  } else if (category === "women") {
    return "/women/";
  } else if (category === "over40") {
    return "/over40/";
  } else {
    return "/";
  }
};

export const getPathPrefix2 = () => {
  if (window.location.href === "https://usa.fastbetter.com/") {
    return "usa";
  } else if (window.location.href === "https://uk.fastbetter.com/") {
    return "uk";
  } else if (window.location.href === "https://us.fastbetter.com/") {
    return "us";
  } else if (window.location.href === "https://ca.fastbetter.com/") {
    return "ca";
  } else if (window.location.href === "https://aus.fastbetter.com/") {
    return "aus";
  } else {
    return "us";
  }
};

// ALL ABOVE USE LESS

export const useGoToPage = () => {
  const navigate = useNavigate();
  const goToPage = (itemLabel, itemName, page = "/") => {
    const urlPre = getPathPrefix();
    if (itemLabel) {
      secureLocalStorage.setItem(itemLabel, itemName);
    }
    navigate(urlPre + page);
  };
  return goToPage;
};
export const maskEmail = (email) => {
  const atIndex = email.indexOf("@");
  if (atIndex !== -1) {
    const maskedPart = email.substring(0, 2) + "*".repeat(atIndex - 2);
    const maskedEmail = maskedPart + email.substring(atIndex);
    return maskedEmail;
  } else {
    return email; // If there's no "@" symbol, return the original email
  }
};

export const generalPages = () => {
  const get_header = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  axios
    .post(GET_GENERAL_PAGES, { country: "us" }, get_header)
    .then((response) => {
      console.log(response.data);
      return JSON.stringify(response.data);
    })
    .catch((error) => {
      return error;
    });
};

export const getNotificationNum2 = async () => {
  try {
    const accessToken = secureLocalStorage.getItem("accessToken");
    const get_header = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(GET_MOOD_NOTIFICATION, get_header);

    return response.data;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    return []; // You might want to handle the error differently depending on your needs
  }
};

export const calculateTimeDifference = (
  currentTime,
  endTime,
  eatStart,
  eatEnd,
  calculateTypeFor,
  windowStatus,
  logTime
) => {
  // Convert time strings to Date objects
  const [currentHours, currentMinutes, currentSeconds] = currentTime
    .split(":")
    .map(Number);
  const [endHours, endMinutes, endSeconds] = endTime.split(":").map(Number);
  const [startHours, startMinutes, startSeconds] = eatStart
    .split(":")
    .map(Number);
  const [endEatHours, endEatMinutes, endEatSeconds] = eatEnd
    .split(":")
    .map(Number);

  // console.log({ currentTime, endTime, eatStart, eatEnd, calculateTypeFor });
  // Calculate total seconds for current and end time

  let totalCurrentTime;
  if (windowStatus === "stop" && logTime) {
    const [logHours, logMinutes, logSeconds] = logTime.split(":").map(Number);
    totalCurrentTime = logHours * 3600 + logMinutes * 60 + logSeconds;
  } else {
    totalCurrentTime =
      currentHours * 3600 + currentMinutes * 60 + currentSeconds;
  }
  const totalEndTime = endHours * 3600 + endMinutes * 60 + endSeconds;

  // console.log(logTime);

  // Calculate total seconds for eating window
  const totalStartTime = startHours * 3600 + startMinutes * 60 + startSeconds;
  const totalEndEating =
    endEatHours * 3600 + endEatMinutes * 60 + endEatSeconds;
  const eatingDurationInSeconds = totalEndEating - totalStartTime;

  // Calculate eating hours and fasting hours
  const eating_hours = eatingDurationInSeconds / 3600;
  const fasting_hours = 24 - eating_hours;

  // Calculate the elapsed eating time in seconds
  const elapsedEatingTimeInSeconds = Math.max(
    0,
    totalCurrentTime - totalStartTime
  );

  // Calculate completed percentage
  let completedPercentage = (
    (elapsedEatingTimeInSeconds / eatingDurationInSeconds) *
    100
  ).toFixed(2);

  // Prepare the output
  let hours = Math.floor(elapsedEatingTimeInSeconds / 3600);
  let minutes = Math.floor((elapsedEatingTimeInSeconds % 3600) / 60);
  let seconds = elapsedEatingTimeInSeconds % 60;

  if (calculateTypeFor === "fasting") {
    hours = 24 - hours;
    minutes = 60 - minutes;
    seconds = 60 - seconds;
    completedPercentage = (
      (elapsedEatingTimeInSeconds / (86400 - eatingDurationInSeconds)) *
      100
    ).toFixed(2);
  }

  return {
    hours,
    minutes,
    seconds,
    completedPercentage,
    eating_hours,
    fasting_hours,
  };
};

// finalSetDataWithDate;>logInMinutes_eating||logInMinutes_fasting
export const convertMinutesToHMS = (
  currentTime24hr,
  endTime24hr,
  eatstart12,
  eatend12,
  logInMinutes_eating,
  logInMinutes_fasting,
  calculateTypeFor,
  windowStatus,
  logTime
) => {
  let hours = 0;
  let minutes = 0;
  let seconds = 0;
  let completedPercentage = 0;
  let eating_hours = 0;
  let fasting_hours = 0;
  // Parse eating start and end times
  const eatStartTime = new Date(`1970-01-01T${eatstart12}Z`);
  const eatEndTime = new Date(`1970-01-01T${eatend12}Z`);

  // Calculate total eating time in minutes
  let totalEatingTimeMinutes = (eatEndTime - eatStartTime) / 60000;
  let logInMinutes = logInMinutes_eating;
  if (calculateTypeFor === "eating") {
    logInMinutes = logInMinutes_eating;
    completedPercentage = (logInMinutes / totalEatingTimeMinutes) * 100;
  } else {
    logInMinutes = logInMinutes_fasting;
    completedPercentage =
      (logInMinutes / (1440 - totalEatingTimeMinutes)) * 100;
  }

  // Calculate completed percentage

  completedPercentage = Math.min(completedPercentage, 100);

  // Calculate remaining minutes for eating and fasting
  eating_hours = totalEatingTimeMinutes / 60;
  fasting_hours = 24 - eating_hours;

  // Convert logInMinutes_eating into hours, minutes, seconds
  hours = Math.floor(logInMinutes / 60);
  minutes = logInMinutes % 60;
  seconds = 0; // Assuming seconds are 0 since we only have whole minutes

  // Log the inputs for debugging

  return {
    hours,
    minutes,
    seconds,
    completedPercentage,
    eating_hours,
    fasting_hours,
  };
};

// Dashboard usage
export const convertTo24HourFormat = (time12h) => {
  const [time, modifier] = time12h.split(" ");
  let [hours, minutes] = time.split(":").map(Number);

  if (modifier === "PM" && hours < 12) {
    hours += 12;
  } else if (modifier === "AM" && hours === 12) {
    hours = 0;
  }

  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:00`;
};

// Dashboard usage.
export const formatTimestamp = (timestamp) => {
  // Extract the date part from the timestamp
  const datePart = timestamp.split(" at ")[0];
  const timePart = timestamp.split(" at ")[1].split(" GMT")[0]; // Get time without timezone

  // Create a Date object from the date part and time part
  const fullDate = new Date(`${datePart} ${timePart}`);

  // Options for formatting to 12-hour format
  const options = {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  // Get the time in 12-hour format
  const time12h = fullDate.toLocaleString("en-US", options);

  // Convert to 24-hour format
  return time12h;
};

export const daysOfWeek = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

export const monthlist = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

// Current week with custom starting day {Sunday or Monday}
export const getCurrentWeek = (startingDay) => {
  const today = new Date();
  let startOfWeek;

  // Calculate start of the week based on the starting day
  if (startingDay === "Sunday") {
    startOfWeek = new Date(today.setDate(today.getDate() - today.getDay()));
  } else if (startingDay === "Monday") {
    startOfWeek = new Date(today.setDate(today.getDate() - today.getDay() + 1));
  } else {
    throw new Error("Starting day must be 'Sunday' or 'Monday'");
  }

  // Generate the week dates and day names
  const weekDates = [];
  for (let i = 0; i < 7; i++) {
    const day = new Date(startOfWeek);
    day.setDate(startOfWeek.getDate() + i);
    weekDates.push({
      date: day.toISOString().split("T")[0],
      dayName: day.toLocaleDateString("en-US", { weekday: "long" }),
    });
  }

  return weekDates;
};

// Calender for selected months
export const getDatesWithDayNames = (year, month) => {
  const dates = [];
  const daysInMonth = new Date(year, month + 1, 0).getDate(); // Get total days in the month

  for (let day = 1; day <= daysInMonth; day++) {
    const date = new Date(year, month, day);

    const options = { weekday: "long" }; // Set options to get full weekday name
    const dayName = date.toLocaleDateString("en-US", options);
    const dateNum = date.toLocaleDateString("en-CA");

    dates.push({
      date: dateNum, // Format date as YYYY-MM-DD
      dayName: dayName,
    });
  }
  // console.log(dates);
  return dates;
};

// Google fit link api
export const LinkedGoogleFit = async () => {
  try {
    const accessToken = secureLocalStorage.getItem("accessToken");
    const callbackurl = "https://user.fastbetter.com/";
    const post_header = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    };
    const post_body = {
      callback: callbackurl,
    };
    const respones = await axios.post(
      GOOGLE_FIT_LINKED_ENDPOINT,
      post_body,
      post_header
    );
    return respones.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

// Google fit link api
export const LinkedFitBit = async () => {
  try {
    const accessToken = secureLocalStorage.getItem("accessToken");
    const callbackurl = "https://user.fastbetter.com/";
    const post_header = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    };
    const post_body = {
      callback: callbackurl,
    };
    const respones = await axios.post(
      FIT_BIT_LINKED_ENDPOINT,
      post_body,
      post_header
    );
    return respones.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

// Google unlink google fit
export const UnLinkedGoogleFit = async () => {
  try {
    const accessToken = secureLocalStorage.getItem("accessToken");
    const callbackurl = "https://user.fastbetter.com/";
    const post_header = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    };
    const post_body = {
      callback: callbackurl,
    };
    const respones = await axios.post(
      GOOGLE_FIT_UNLINKED_ENDPOINT,
      post_body,
      post_header
    );
    return respones.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

// Date and day extraction

export const currentMonthYearDay = () => {
  const today = new Date();

  // Get the current day of the week (e.g., "Monday")
  const currentDay = today.toLocaleString("en-US", {
    weekday: "long",
  });

  // Get today's date in a more readable format (e.g., "December 3, 2024")
  // const formattedTodayDate = today.toLocaleDateString("en-US", {
  //   year: "numeric",
  //   month: "numeric",
  //   day: "numeric",
  // });

  const formattedTodayDate = today.toISOString().split("T")[0]; // "YYYY-MM-DD" format

  return {
    currentDay: currentDay,
    formattedTodayDate: formattedTodayDate,
  };
};

// Find the week with the help of the date
export const WeekInMonth = (track_date_arg) => {
  const track_date = track_date_arg || "2024-12-03T11:25:41";
  // Define the date for which we want the week number
  const date = new Date(track_date);

  // Function to calculate the week number in the current month
  const getWeekNumberInMonth = (date) => {
    // Get the first day of the current month
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);

    // Calculate the difference in milliseconds between the given date and the start of the month
    const diff = date.getDate() - startOfMonth.getDate();

    // Calculate the week number (1 week = 7 days)
    // We assume weeks start on Monday, so we use (diff + startOfMonth.getDay()) % 7 to adjust for the first week's start day.
    const weekNumber = Math.floor((diff + startOfMonth.getDay()) / 7) + 1;

    return weekNumber;
  };

  return getWeekNumberInMonth(date);
};
